module.exports = __webpack_public_path__ + "img/H1.b9f9ed97.png";